import { Box, Text, Container, Link } from "@chakra-ui/react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box as="footer" py={4} bg="#131416" mt="auto">
        <Container maxW="container.xl" px={{ base: 4, md: 8 }}>
        <Text fontSize="sm" color="whiteAlpha.700" textAlign="left">
          © {currentYear} Created by <Link href="https://jakeharriscodes.com" target="_blank" color="whiteAlpha.900">Jake Harris Codes</Link>. All rights reserved.
        </Text>
      </Container>
    </Box>
  );
}